export function setMetaTitle(title?: string) {
    const fullTitle = title ? `Ona Druga Grupa | ${title}` : 'Ona Druga Grupa';
    document.title = fullTitle
    const ogTitle = document.querySelector('meta[property="og:title"]');

    if (ogTitle) {
        ogTitle.setAttribute('content', fullTitle);
    }
}

export function setDescription(description?: string) {
    const defaultDescription = 'Ona Druga Grupa je TTRPG zajednica koja se bavi igranjem igara uloga u Zagrebu';
    const metaDescription = document.querySelector('meta[name="description"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');

    if (metaDescription) {
        metaDescription.setAttribute('content', description ?? defaultDescription);
    }

    if (ogDescription) {
        ogDescription.setAttribute('content', description ?? defaultDescription);
    }
}

export function setMetaUrl(url: string = 'https://odg.hr/') {
    const canonical = document.querySelector('link[rel="canonical"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');

    if (canonical) {
        canonical.setAttribute('href', url);
    }

    if (ogUrl) {
        ogUrl.setAttribute('content', url);
    }
}